<template>
    <proposal-iframe
        :padding="true"
        overflow="hidden"
        id="proposal-iframe"
        ref="iframe"
        style="width: 100%; height: 500px; border: 0"
    >       
        <proposal-pricing-option
            v-if="form_data['pricing_option' + number].is_active" 
            v-model="localValue"
            :data="form_data['pricing_option' + number]"
            :recommended="number === 2"
        />
    </proposal-iframe>
</template>

<script>
import ProposalIframe from './proposal-iframe.vue';
import ProposalPricingOption from '../../../ProposalsPresentation2/vue/parts/proposal-31-pricing-option.vue';

export default {
    components: {
        ProposalIframe,
        ProposalPricingOption,
    },
    props: [
        'form_data',
        'number',
    ],
    data() {
        return {            
            localValue: 0,
        };
    },
};
</script>